import React from 'react';
import {RemoveScroll} from 'react-remove-scroll';

import {twx} from '@/utils/tailwindUtils';

import AppPopup from './AppPopup';
import styles from './Popup.module.scss';

const PopupRaw = ({className, overlayClassName, isHidePopup, isBlockerOverlay, isOpen = true, ...rest}) => {
    return (
        <RemoveScroll enabled={!isHidePopup && isOpen}>
            <AppPopup
                className={twx(styles.PopupContainer, className)}
                overlayClassName={twx(styles.Overlay, isBlockerOverlay && styles.BlockerOverlay, overlayClassName)}
                isOpen={isOpen}
                {...rest}
            />
        </RemoveScroll>
    );
};

export default PopupRaw;
